var map = {
	"./decidim/avatar-multiuser.png": 56310,
	"./decidim/brands/google.svg": 55225,
	"./decidim/cc-badge.png": 55464,
	"./decidim/decidim-logo.svg": 15540,
	"./decidim/default-avatar.svg": 34188,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 83800,
	"./decidim/icons.svg": 67335,
	"./decidim/pattern.png": 3080,
	"./decidim/placeholder-card-g.svg": 73133,
	"./decidim/placeholder-card-l.svg": 46086,
	"./decidim/placeholder.jpg": 82437,
	"./decidim/remixicon.symbol.svg": 55561,
	"./decidim/vendor/leaflet/layers-2x.png": 39336,
	"./decidim/vendor/leaflet/layers.png": 63479,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 68354,
	"./decidim/vendor/leaflet/marker-icon.png": 51721,
	"./decidim/vendor/leaflet/marker-shadow.png": 89190,
	"./decidim/vendor/social-share-button/douban.svg": 69832,
	"./decidim/vendor/social-share-button/email.svg": 44709,
	"./decidim/vendor/social-share-button/facebook.svg": 32955,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 25301,
	"./decidim/vendor/social-share-button/hacker_news.svg": 10517,
	"./decidim/vendor/social-share-button/linkedin.svg": 37949,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 29582,
	"./decidim/vendor/social-share-button/pinterest.svg": 19099,
	"./decidim/vendor/social-share-button/reddit.svg": 48783,
	"./decidim/vendor/social-share-button/telegram.svg": 8578,
	"./decidim/vendor/social-share-button/tumblr.svg": 35329,
	"./decidim/vendor/social-share-button/twitter.svg": 66836,
	"./decidim/vendor/social-share-button/vkontakte.svg": 97482,
	"./decidim/vendor/social-share-button/wechat.svg": 86517,
	"./decidim/vendor/social-share-button/whatsapp.svg": 64549,
	"./decidim/vendor/social-share-button/x.svg": 99013,
	"./decidim/vendor/social-share-button/xing.svg": 65531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50561;